var BOLD = BOLD || {};
BOLD.BMS = BOLD.BMS || {};
BOLD.BMS.MS = BOLD.BMS.MS || {};

BOLD.BMS.MS.Product = function($) {
  "use strict";

  var product = null;
  var settings = {};
  
  var gst = null;

  function init(data, options) {
    data = data || {};
    product = data.product || {};

    // Set initial values
    gst = BOLD.BMS.MS.GstSwitcher.gst;

    $.extend(true, settings, options);

    bindEvents();

    Options.init(data.selectedVariantId);

    setPrice(Options.current.variant);
  }

  function initAsync(data, options) {
    getProduct(data, options);
  }

  function bindEvents() {
    BOLD.common.eventEmitter.on("BOLD_COMMON_gst_changed", function (payload) {
      setPrice(Options.current.variant);
      
      // Set text content
      var textContainer = document.querySelector(".price--includes");
      if (textContainer) textContainer.textContent = payload.gst.text;
    });
  }

  var Options = function() {
    var current = {
      _variant: null,
      get variant() {
        return this._variant;
      },
      set variant(value) {
        this._variant = value;
      }
    };

    function init(selectedVariantId) {
      // Set initial values
      current.variant = findVariantById(selectedVariantId);

      bindEvents();
    }

    function bindEvents() {
      BOLD.common.eventEmitter.on('BOLD_COMMON_variant_changed', 
        BOLD.BMS.Common.debounce(
          function (payload) {
            current.variant = payload.variant;
            setPrice(current.variant);
            showMPNDays(current.variant);
          }, 500, true
        )
      );
    }

    return {
      init: init,
      current: current
    }
  }();

  function showMPNDays(variant) {
    var leadTimeMessage = $('.product__lead_time');
    variant.inventory_quantity === 0 ? leadTimeMessage.show() : leadTimeMessage.hide();
  }

  function setPrice(variant) {
    var target = document.querySelector(".price--main .money");

    if (target) {
      var lineItem = BOLD.BMS.CSPQB.fixVariant(variant);
      var cost = ((gst.isIncluded && variant.taxable) ? BOLD.BMS.CSPQB.calculateGstPrice(lineItem.price) : lineItem.price);

      target.textContent = BOLD.common.Shopify.formatMoney(cost);
    }
  }

  function findVariantById(id) {
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      var current = product.variants[i];
      if (current.id === id) {
        variant = current;
        break;
      }
    }
    return variant;
  }

  function getProduct(data, options) {
    data = data || {};
    var url = location.protocol + "//" + location.hostname + location.pathname + ".js";

    $.getJSON(url)
      .done(function(result) {
        data.product = result;
        init(data, options);
      })
      .fail(function(err) {
        console.error(err);
      }
    );
  }

  return {
    init: init,
    initAsync: initAsync
  };

}(BOLD.jQuery || jQuery);